import { Box, Flex, rem } from 'affiny-ui/src';
import React, { Dispatch, SetStateAction } from 'react';
import { HEADER_HEIGHT } from './layer/LayerHeader';
import { Tab } from './Tab';

interface ITabs {
  setSection: Dispatch<SetStateAction<string>>;
  sections: {
    label: string;
    title: string;
  }[];
  section: string;
  margin?: number;
}

export const Tabs = ({ setSection, sections, section, margin = 64 }: ITabs) => {
  return (
    <Flex
      position="sticky"
      top={HEADER_HEIGHT}
      zIndex={1}
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      flexGrow={0}
      backgroundColor="light"
    >
      {sections.map(({ label, title }, idx) => (
        <Box
          key={label}
          mr={idx < sections.length - 1 ? rem(margin) : 0}
          onClick={() => setSection(label)}
          data-test={`personality-tab-${label}`}
        >
          <Tab isSelected={section === label} title={title} />
        </Box>
      ))}
    </Flex>
  );
};
